import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";

import { SortableList } from "altus-ui-components";
import { isModalOpen, toggleModal } from "altus-modal";

import { EMPTY_LIST } from "app/app.constants";
import ModalHeader from "app/components/Modal/ModalHeader";
import { SORT_DIRECTION } from "features/planner/planner.constants";

class DashboardEmployeesModal extends PureComponent {
  toggleModal = () => {
    const { dispatchToggleModal, modalId } = this.props;

    dispatchToggleModal({
      modalId,
    });
  };

  columns = [
    {
      xs: true,
      title: "Group",
      filter: {
        defaultText: "All",
      },
      getSortProperty: item => item.get("groupName"),
    },
    {
      xs: true,
      title: "First Name",
      getSortProperty: item => item.getIn(["employee", "firstName"]),
    },
    {
      xs: true,
      title: "Last Name",
      getSortProperty: item => item.getIn(["employee", "lastName"]),
    },
  ];

  render() {
    const { open, employees, title } = this.props;

    return (
      <Dialog fullWidth open={open} maxWidth="md" onClose={this.toggleModal}>
        <ModalHeader toggleModal={this.toggleModal} title={title} />
        <DialogContent>
          <SortableList
            stickyHeader={false}
            columns={this.columns}
            getKey={item => item.get("employeeId")}
            items={employees}
            defaultSortDirection={SORT_DIRECTION.DESC}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
    );
  }
}

DashboardEmployeesModal.defaultProps = {
  employees: EMPTY_LIST,
};

export default compose(
  connect(
    (state, { modalId }) => ({
      open: isModalOpen(state, modalId),
    }),
    {
      dispatchToggleModal: toggleModal,
    },
  ),
)(DashboardEmployeesModal);
